import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserModel } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private userSubject: BehaviorSubject<UserModel>;
  public user: Observable<UserModel>;


  constructor(
    private router: Router
  ) {
    this.userSubject = new BehaviorSubject<UserModel>({});
    this.user = this.userSubject.asObservable();

    window.addEventListener('storage', (event) => {
      if (event.key === 'logout') {
        this.router.navigate(['/login']);
      }
    });
  }

  public setUser(user: UserModel): void {
    this.userSubject.next(user);
  }

  public LogOut(): void {
   this.userSubject.next({} as UserModel);
   this.router.navigate(['/login']);
  }
}
